import { Component, Inject, Input, OnChanges, OnInit, Optional, SimpleChanges } from '@angular/core';
import { Grid } from '@app/core/components/grid/grid.model';
import { GridOptions } from '@app/core/components/grid/grid.types';
import { ListCheckboxSelectionEvent } from '@app/core/components/list/directives/list-checkbox-selection.directive';
import { ListButton } from '@app/core/components/list/list.component';
import { Item } from '@app/core/components/listbox/listbox.component';
import { DataTaskService } from '@app/core/services/data-task.service';
import { TT_FONT_SIZES } from '@app/core/services/layout.service';
import { ModalService } from '@app/core/services/modal.service';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { GetKpiCompParams, KpiCompGet, KpiCompService, KpiCompSlicerItem, KpiCompTypeItem } from '@app/services/kpi-comp.service';
import { TypeaheadService } from '@app/services/typeahead.service';

@Component({
    selector: 'tt-kpi-comp',
    templateUrl: './kpi-comp.component.html',
    styleUrls: ['./kpi-comp.component.css'],
})
export class KpiCompComponent implements OnChanges, OnInit {
    @Input()
    public params?: GetKpiCompParams;

    public get?: KpiCompGet;

    public kpiTypes: KpiCompTypeItem[] = [];

    public slicers: KpiCompSlicerItem[] = [];

    public fontSizes = TT_FONT_SIZES;

    webpages: any[] = [];

    public saving = false;

    public grid?: GridOptions;

    constructor(
        private kpiComp: KpiCompService,
        private datatask: DataTaskService,
        private typeahead: TypeaheadService,
        private modal: ModalService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator,
    ) {
        this.navigator = useNavigatorFor(navigator, this);
    }

    public searchWebpages = async ({ value }: { value: string | null }) => {
        return this.typeahead.searchWebpages({ searchtext: value ?? '' });
    };

    public openTranslateDialog(wordId: string, text: string) {
        //
        if (!!this.get) {
            this.modal.openTranslationDialog({ word_id: wordId, heading: this.get.kpicomp_name, textToTranslate: text });
        }
    }

    public async save() {
        if (!this.get) return;

        try {
            this.saving = true;

            const { errorcode, errormessage } = await this.kpiComp.saveKpiComp(this.get);

            if ('' + errorcode !== '0') {
                this.modal.show({ type: 'warning', title: 'error', translateTitle: true, message: errormessage });
            } else {
                this.navigator?.back(undefined, this.get);
            }
        } catch (error) {
            console.error(error);
        } finally {
            this.saving = false;
        }
    }

    public onSlicersChanged(event: ListCheckboxSelectionEvent<Item>) {
        if (!!this.params) {
            this.datatask.Post(3589, { ...this.params, kpislicer_keyno: event.item.item_id, item_is_selected: event.item.item_is_selected });
        }
    }

    private async loadGet() {
        if (!!this.params) {
            this.get = await this.kpiComp.getKpiComp(this.params);
        }
    }

    private async loadSlicers() {
        if (!!this.params) {
            this.slicers = await this.kpiComp.getKpiCompSlicers(this.params);
        }
    }

    private async loadKpiTypes() {
        this.kpiTypes = await this.kpiComp.getKpiCompTypes();
    }

    private async loadWebpages() {
        this.webpages = await this.datatask.Post(1890);
    }

    private readGrid() {
        if (!this.grid) {
            this.grid = new Grid()
                .setRememberId('kpicomp_usergroup_grid')
                .setLoadDataFunction({ method: 3520, parameters: () => this.params })
                .setCSSOptions({ minHeight: '500px' });
        } else {
            this.grid.gridfunc?.read();
        }
    }

    private async staticDataInit() {
        this.loadKpiTypes();
        this.loadWebpages();
    }

    private async init() {
        this.readGrid();
        this.loadSlicers();
        await this.loadGet();
    }

    ngOnInit(): void {
        this.staticDataInit();

        if (!!this.navigator) {
            this.params = this.navigator.params as any;
            this.init();
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['params']) {
            this.init();
        }
    }

    buttons: ListButton<any>[] = [{ id: 'edit', icon: 'far fa-pencil', type: 'primary', onClick: () => alert('open edit dialog') }];
}
